module.exports = "/_next/static/images/horse_manage_right-851b722f29a7455ebda7105520b19db1.png";